<template>
    <li>
        <div
                class="accordion-title has-toggle"
                @click="toggle()"
                :class="{active: open}"
        >
            {{item.title}}
            <span class="toggle"></span>
        </div>
        <div class="accordion-content" v-if="open">
            <div v-html="item.content" v-if="item.options==false"></div>
            <div v-else>
                <table>
                    <tr v-for="(option, key) in item.options" :key="key">
                        <td>{{option.title}}</td>
                        <td>{{option.content}}</td>
                    </tr>
                </table>
            </div>
        </div>
    </li>
</template>

<script>
  export default {
    props: ['item'],
    data () {
      return {
        open: false
      }
    },
    methods: {
      toggle () {
        this.open = !this.open
      }
    }
  }
</script>

<style lang="scss">
    .accordion {
        max-width: 1130px;
        margin: auto;

        ul {
            width: 100%;
            li {
                border-bottom: 1px solid #919191;
                &:first-child {
                    border-top: 1px solid #919191;
                }
                .accordion-title {
                    font-family: $font-bold;
                    cursor: pointer;
                    padding-right: 40px;
                    padding-top: 15px;
                    padding-bottom: 15px;
                }
                .accordion-content {
                    line-height: 24px;
                    margin-bottom: 15px;

                    table{
                        width: 100%;
                        border-collapse: collapse;
                        td{
                            border: 1px solid #e5e6e7;
                            padding: 5px 10px;
                        }
                    }
                }
            }
        }
    }
</style>
